import { render, staticRenderFns } from "./journeyList.vue?vue&type=template&id=d0491292&scoped=true"
import script from "./journeyList.vue?vue&type=script&lang=js"
export * from "./journeyList.vue?vue&type=script&lang=js"
import style0 from "./journeyList.vue?vue&type=style&index=0&id=d0491292&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0491292",
  null
  
)

export default component.exports